<template>
  <div
      class="group-node" :class="{ 'first-node': isFirstNode, 'last-node': isLastNode }"
      :style="{ '--line-height': lineHeight + 'px' }"
      ref="groupNode"
  >
    <div
        class="group-node-label" :class="{ 'first-node': isFirstNode, 'selected': isSelected, 'group-node': isGroupNode }"
        @click="handleClick" ref="nodeLabel"
    >
      <!-- 토글 버튼: 자식 노드가 있을 경우에만 노출 -->
      <button
          v-if="hasChildren"
          class="toggle-button"
          @click.stop="toggleChildren"
      >{{ expanded ? '-' : '+' }}</button>
      <v-icon v-if="isFirstNode">
        mdi-office-building
      </v-icon>
      <v-icon class="node-icon" v-else>
        {{ node.type === "ORG" ? "mdi-account-multiple" : "mdi-account" }}
      </v-icon>
      <span v-if="isFirstNode">{{ node.name }}</span>
      <span v-else>{{ (node.type === "ORG") && !notTeamList.includes(node.name) ? node.name + "팀" : node.name }}
        <span v-if="node.type !== 'USER'">({{ dataConversion(orgTypeList, node.type) }})</span>
      </span>
    </div>
    <!-- 자식 노드는 expanded가 true일 때만 표시 -->
    <div class="group-children" v-if="hasChildren && expanded">
      <group-node
          v-for="(child, index) in node.children"
          :key="child.id"
          ref="childRefs"
          :ref-in-for="true"
          :node="child"
          @select="handleSelect"
          :is-first-node="false"
          :is-last-node="index === node.children.length - 1"
          :selected="selected"
      />
    </div>
  </div>
</template>

<script>
import constant from "@/util/constant";
import TableMixin from "@/mixin/TableMixin";

export default {
  name: "GroupNode",
  props: ["node", "isLastNode", "isFirstNode", "selected"],
  mixins: [TableMixin],
  data() {
    return {
      notTeamList: ["인카모기지", "기획실", "에인"],
      orgTypeList: constant.ORG_TYPE_LIST,
      lineHeight: 0,
      expanded: false  // 자식 노드 표시 여부: false = 닫힘, true = 열림
    };
  },
  computed: {
    hasChildren() {
      return this.node.children && this.node.children.length > 0;
    },
    isSelected() {
      return this.selected && this.node.id === this.selected.id;
    },
    isGroupNode() {
      return this.node.type === "ORG";
    }
  },
  mounted() {
    this.adjustLineHeight();
  },
  methods: {
    handleClick() {
      this.$emit("select", this.node);
    },
    toggleChildren() {
      this.expanded = !this.expanded;
    },
    handleSelect(node) {
      this.$emit("select", node);
    },
    adjustLineHeight() {
      const nodeLabel = this.$refs.nodeLabel;
      if (nodeLabel) {
        const labelOffsetTop = nodeLabel.offsetTop;
        const labelHeight = nodeLabel.offsetHeight;
        this.lineHeight = labelOffsetTop + labelHeight / 2;
      }
    },
    // 전체 확장
    expandAll() {
      this.expanded = true;
      this.$nextTick(() => {
        this.$refs.childRefs?.forEach(child => {
          if (child && typeof child.expandAll === 'function') {
            child.expandAll();
          }
        });
      });
    },
    // 전체 축소
    collapseAll() {
      this.expanded = false;
      this.$nextTick(() => {
        this.$refs.childRefs?.forEach(child => {
          if (child && typeof child.collapseAll === 'function') {
            child.collapseAll();
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.group-node {
  position: relative;
  padding: 10px 20px;
  --line-height: 100%;
}

/* 수직 라인 */
.group-node::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  background-color: gray;
  height: 100%;
}
.group-node.last-node::before {
  height: var(--line-height, 100%);
}

.group-node.first-node::before {
  background-color: white;
}

/* 노드 라벨 */
.group-node-label {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  white-space: nowrap;
  cursor: pointer;
}

/* 토글 버튼 스타일 */
.toggle-button {
  padding: 0 8px;
  margin-right: 5px;
  font-weight: bold;
  cursor: pointer;
  border: 1px solid #c0c0c0;
  background-color: white;
}

/* 선택된 노드 스타일 */
.group-node-label.selected {
  background-color: #1772C7 !important;
  border-color: #1772C7;
  color: white;
}

.group-node-label.selected .toggle-button {
  color: black;
}

/* 그룹 노드 스타일 */
.group-node-label.group-node {
  background-color: #d0d0d0;
}

/* 수평 라인 */
.group-node-label::before {
  content: "";
  position: absolute;
  top: 50%;
  left: -20px;
  width: 20px;
  height: 2px;
  background-color: gray;
  transform: translateY(-50%);
}

.group-node-label.first-node::before {
  background-color: white;
  z-index: -1;
}

.group-children {
  margin-left: 20px;
}
</style>
